import { connect, DispatchProp } from 'react-redux';
import { AnyAction } from 'redux';

import { popularJobTypesSelector, relatedJobTypesSelector } from 'modules/job-types/duck';
import {
  citiesSelector,
  cityGroupsSelector,
  cityPartSelector,
  prefecturePartSelector,
  prefecturesSelector,
} from 'modules/locations/duck';
import {
  daySelector,
  proReviewStatisticsSelector,
  blogPostsSelector,
  proBlogPostsSelector,
  timeSelector,
} from 'modules/marketing-pages/duck';
import { translationSelector } from 'modules/translations/duck';
import type { RootState } from 'src/store/types';

import LandingPage from './LandingPage';

interface PropsForRedux {
  cityId?: string;
  day?: string;
  jobTypeId: string;
  pageTranslationId: 'areaPrefectureCityJobTypePage' | 'areaPrefectureVertical' | 'verticalLP';
  prefectureId?: string;
}

const mapStateToProps = (state: RootState, props: PropsForRedux) => ({
  cities: citiesSelector(state),
  // @ts-expect-error citySelector not yet typed
  city: cityPartSelector(state, { cityKey: props.cityId }) as {
    _id: string;
    id: string;
    key: string;
    name: string;
  },
  day: daySelector(state),
  cityGroups: cityGroupsSelector(state),
  popularJobTypes: popularJobTypesSelector(state),
  // todo: if we do a partial release may want to leverage this or prefix the internalBlogPost context structure
  // to check the current jobType otherwise fall back to this.
  posts: blogPostsSelector(state),
  // @ts-expect-error prefectureSelector not yet typed
  prefecture: prefecturePartSelector(state, { prefectureKey: props.prefectureId }) as {
    _id: string;
    id: string;
    key: string;
    name: string;
  },
  prefectures: prefecturesSelector(state),
  proBlogPosts: proBlogPostsSelector(state),
  proReviewStatistics: proReviewStatisticsSelector(state),
  relatedJobTypes: relatedJobTypesSelector(state, props),
  time: timeSelector(state),
  translation: translationSelector(state, { translationId: props.pageTranslationId }),
});

export type ReduxProps = ReturnType<typeof mapStateToProps> & DispatchProp<AnyAction>;

export default connect(mapStateToProps)(LandingPage);
